export const loadDashboardView = () => import("./views/dashboard.view");
